import { render, staticRenderFns } from "./SettingsUserData.vue?vue&type=template&id=b572d646&scoped=true"
import script from "./SettingsUserData.vue?vue&type=script&lang=js"
export * from "./SettingsUserData.vue?vue&type=script&lang=js"
import style0 from "./SettingsUserData.vue?vue&type=style&index=0&id=b572d646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b572d646",
  null
  
)

export default component.exports